import "./icon.css"
import { IconProps } from "./icon.props";

const Icon: React.FC<IconProps> = ({ icon, alt, className }) => {
  return <img src={icon} alt={alt} className={className} />;
};

export default Icon;